import { render, staticRenderFns } from "./OptometryPendingForm.vue?vue&type=template&id=75c5acd2&"
import script from "./OptometryPendingForm.vue?vue&type=script&lang=js&"
export * from "./OptometryPendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports